module.exports = "/assets/js/1e8940896853a0fe355f4f8b90aa01ba.svg";